module.exports = __webpack_public_path__ + "static/corezoid-logo-2-3c8ce0f2a51f643a7bf421c6d0f27469.png";